module.exports = __webpack_public_path__ + "static/img/tipsOrange.314bcb69.png";